import styled from 'styled-components';

export const MessageWrapper = styled.div`
    margin-bottom: 16px;
`;
